/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Add_A_Title_FirstInputs */

const en_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a title first`)
};

const es_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade un título primero`)
};

const fr_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajoutez un titre d'abord`)
};

const de_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Füge zuerst einen Titel hinzu`)
};

const ja_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最初にタイトルを追加してください`)
};

const zh_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`请先添加一个标题`)
};

const ar_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أضف عنواناً أولاً`)
};

const id_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tambahkan judul terlebih dahulu`)
};

const it_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi prima un titolo`)
};

const ru_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сначала добавьте заголовок`)
};

const pt_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione um título primeiro`)
};

const ko_add_a_title_first = /** @type {(inputs: Add_A_Title_FirstInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`먼저 제목을 추가하세요`)
};

/**
* | output |
* | --- |
* | "Add a title first" |
*
* @param {Add_A_Title_FirstInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const add_a_title_first = /** @type {((inputs?: Add_A_Title_FirstInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Add_A_Title_FirstInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_add_a_title_first(inputs)
	if (locale === "es") return es_add_a_title_first(inputs)
	if (locale === "fr") return fr_add_a_title_first(inputs)
	if (locale === "de") return de_add_a_title_first(inputs)
	if (locale === "ja") return ja_add_a_title_first(inputs)
	if (locale === "zh") return zh_add_a_title_first(inputs)
	if (locale === "ar") return ar_add_a_title_first(inputs)
	if (locale === "id") return id_add_a_title_first(inputs)
	if (locale === "it") return it_add_a_title_first(inputs)
	if (locale === "ru") return ru_add_a_title_first(inputs)
	if (locale === "pt") return pt_add_a_title_first(inputs)
	return ko_add_a_title_first(inputs)
});